module.exports = __webpack_public_path__ + "media/a7.4445c62a.wav";